/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refund_None_HintInputs */

const vi_refund_none_hint = /** @type {(inputs: Refund_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phần khách trả thừa thành tiền dư của khách, trừ vào đơn sau hoặc hoàn sau ở tab công nợ.`)
};

/**

* @param {Refund_None_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_none_hint = /** @type {((inputs?: Refund_None_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_None_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_none_hint(inputs)
});